import logoFplayt from '../../assets/fplaytLogo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import {useEffect} from 'react';
import { useTheme } from './ThemeContext';
import { useData } from './MemberData';
import Cookies from 'js-cookie';

let myDiscordID = ''

function HeaderBar({ currentPage }: any) {
    const { theme, toggleTheme } = useTheme();
    const { membersData } = useData();
    let userName = null
    
    useEffect(() => {
        myDiscordID = Cookies.get('myDiscordID') || '';
        if (myDiscordID === '') {
            let email = Cookies.get('email');
            for (let index = 0; index < membersData.length; index++) {
                const element = membersData[index];
                if (element.email === email) {
                    Cookies.set("myDiscordID", element.discordID)
                    myDiscordID = element.discordID
                }
            }
        }
        if (theme === "dark") {
            document.getElementById("darkTheme")!.style.backgroundColor = '#ffffff';
            document.getElementById("lightTheme")!.style.backgroundColor = 'transparent';
            document.documentElement.classList.add("dark");
        } else {
            document.getElementById("darkTheme")!.style.backgroundColor = 'transparent';
            document.getElementById("lightTheme")!.style.backgroundColor = '#ffffff';
            document.documentElement.classList.remove("dark");
        }
    });

    for (let index = 0; index < membersData.length; index++) {
        const element = membersData[index];
        if (element.discordID === myDiscordID) {
            userName = `[M-${String(element.callsign).padStart(3, '0')}] ${element.full_name}`
        }
    }
    
    return (
        <div className="w-full h-[11%] flex items-center justify-between">
            <span className="textBold text-[#323232] dark:text-[#ffffff] text-[1.3vw]">Panel Medici / {currentPage}</span>
            <div className="w-[4.5%] bg-[#F0F0F0] dark:bg-[#BFBFBF] rounded-full flex items-center justify-between p-[.2vw]">
                <FontAwesomeIcon id="darkTheme" onClick={toggleTheme} className="cursor-pointer text-[#323232] dark:text-[#323232] text-[1vw] rounded-full bg-transparent p-[.4vw] px-[.55vw]" icon={faMoon} />
                <FontAwesomeIcon id="lightTheme" onClick={toggleTheme} className="cursor-pointer text-[#323232] dark:text-[#323232] text-[1vw] rounded-full bg-white p-[.4vw]" icon={faSun} />
            </div>
            <div className="w-[20%] h-full flex items-center justify-end gap-[2%] pr-[1%]">
                {/* <FontAwesomeIcon className="cursor-pointer text-[#323232] dark:text-[#ffffff] text-[1vw] rounded-full bg-transparent p-[.4vw]" icon={faBell} />
                <FontAwesomeIcon className="cursor-pointer text-[#323232] dark:text-[#ffffff] text-[1vw] rounded-full bg-transparent p-[.4vw]" icon={faEnvelope} /> */}
                <span className="text-wrap text-right textMedium text-[#323232] dark:text-[#ffffff] text-[0.8vw]">{userName}</span>
                <img className="w-[20%]" src={logoFplayt} alt="" />
            </div>
        </div>
    )
}

export default HeaderBar;